import { render } from "./StageFrame.vue?vue&type=template&id=7f97ef7a&scoped=true"
import script from "./StageFrame.vue?vue&type=script&lang=js"
export * from "./StageFrame.vue?vue&type=script&lang=js"

import "./StageFrame.vue?vue&type=style&index=0&id=7f97ef7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f97ef7a"]])

export default __exports__